<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
      <div class="tu-class">
        <p v-html="strnei" >{{strnei}}</p>
      </div>
    </div>
    <div class="lct-class num1-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程历史跟踪
      </h3>
      <el-table :data="tableData" border>
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
        <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
        <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
        <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { processInstanceImage } from "@/api/api.js";//流程图
import { historicActivityInstance } from "@/api/api.js";//记录展示
import { processData } from "@/api/api.js";//附加单据
export default {
  data() {
    return{
      str:"",
      strnei:"",
      tableData:[]
    }
  },
  methods: {
    // 获取数据
    initData(){
      let params ={
        processInstanceId:this.iccid =  this.$route.params && this.$route.params.id
      }
      processInstanceImage(params).then(res=>{
        this.str = res.data
      });
      historicActivityInstance(params).then(res=>{
        if (res.data.code == 200) {
          this.tableData = res.data.data;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
          })
        }
      });
      processData(params).then(res=>{
        if (res.data.code == 200) {
          this.strnei = res.data.data;
        }
      })
    },

  },
  created() {
    
  },
  mounted() {
    this.initData()
  },
};
</script>
<style scoped lang="less">
.lct-class{
  padding-bottom: 50px;
  .detail-h3 {
    font-size: 20px;
    color: #000000;
    padding-bottom: 30px;
    box-sizing: border-box;
  }
  .detail-h3 i {
    color: #5298ff;
  }
}
</style>


